import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router";
import { useFirestore } from "reactfire";
import ieeeLogo from "../../../shared/resources/in-logo-small-no-text.png";
import {
  FaFacebookF,
  FaGlobe,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { Country } from "../../../shared/constants/Constant";
import { TeamData } from "../../dashboard/containers/teams/companies/Companies";
import { BiArrowBack } from "react-icons/bi";

const PublicCompanyView = () => {
  const { id } = useParams() as any;
  const [state, setState] = useState<TeamData>();
  const store = useFirestore();
  const { push } = useHistory();

  //get team data
  useEffect(() => {
    let isUnmount = false;
    store
      .collection("teams")
      .doc(id)
      .get()
      .then((snap) => {
        const data = snap.data() as TeamData;
        if (!isUnmount)
          setState({
            id: snap.id,
            logo: data.logo || "",
            industryTags: data.industryTags || [],
            country: data.country || Country.SRI_LANKA,
            founded: data.founded || "",
            facebook: data.facebook || "",
            linkedIn: data.linkedIn || "",
            twiter: data.twiter || "",
            youtube: data.youtube || "",
            website: data.youtube || "",
            instagram: data.instagram || "",
            companyName: data.companyName || "",
            oneLineIntro: data.oneLineIntro || "",
            overview: data.overview || "",
            founders: data.founders || [],
            updatedBy: data.updatedBy,
            updatedByUserName: data.updatedByUserName,
          });
      })
      .catch((error) => {
        console.log(error);
      });
    return () => {
      isUnmount = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getCountryString = (c: Country) => {
    switch (c) {
      case Country.BOSNIA:
        return "Bosnia and Herzegovina";
      case Country.JAMAICA:
        return "Jamaica";
      case Country.MALAYSIA:
        return "Malaysia";
      case Country.INDIA:
        return "India";
      case Country.INDONESIA:
        return "Indonesia";
      default:
        return "Sri Lanka";
    }
  };

  return (
    <div style={{ backgroundColor: "rgb(255,255,255)" }}>
      <div className="back-arrow" onClick={() => push("/companies")}>
        <BiArrowBack />
      </div>

      <div className="company-main-wrapper">
        <div className="c-container">
          <div
            style={{
              paddingBottom: "40px",
              paddingTop: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={ieeeLogo}
                alt=""
                style={{ width: "70px", transform: "translateX(-10px)" }}
              />
              <h3
                style={{
                  color: "#006699",
                  marginLeft: "30px",
                  fontSize: "40px",
                }}
              >
                IEEE Innovation Nation Fellows
              </h3>
            </div>
          </div>
          <div style={{ display: "flex" }} className="section">
            <div style={{ marginTop: "35px", width: "100px", color: "#888" }}>
              <label>About</label>
            </div>
            <div style={{ flex: 1 }}>
              <Container fluid>
                <Row className="c-header">
                  <div style={{ width: "250px" }} className="image-wrapper">
                    <img src={state?.logo} alt={state?.oneLineIntro} />
                  </div>
                  <div style={{ flex: 1 }} className="infor-wrapper">
                    <div>
                      {state?.industryTags?.map((t, index) => (
                        <label key={index} className="tag">
                          {t}
                        </label>
                      ))}
                    </div>
                    <div>Founded: {state?.founded}</div>
                    <div>
                      Location:{" "}
                      {getCountryString(state?.country || Country.SRI_LANKA)}
                    </div>
                    <div
                      style={{
                        fontSize: "20px",
                        display: "flex",
                        alignContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {state?.facebook && (
                        <a
                          href={state?.facebook}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaFacebookF
                            style={{ color: "#4267B2", cursor: "pointer" }}
                          />
                        </a>
                      )}
                      {state?.twiter && (
                        <a
                          href={state?.twiter}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaTwitter
                            style={{ color: "#1DA1F2", cursor: "pointer" }}
                          />
                        </a>
                      )}
                      {state?.youtube && (
                        <a
                          href={state?.youtube}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaYoutube
                            style={{ color: "#c4302b", cursor: "pointer" }}
                          />
                        </a>
                      )}
                      {state?.linkedIn && (
                        <a
                          href={state?.linkedIn}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaLinkedinIn
                            style={{ color: "#0e76a8", cursor: "pointer" }}
                          />
                        </a>
                      )}
                      {state?.website && (
                        <a
                          href={state?.website}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaGlobe
                            style={{ color: "#0e76a8", cursor: "pointer" }}
                          />
                        </a>
                      )}
                      {state?.instagram && (
                        <a
                          href={state?.instagram}
                          target="_blank"
                          className="smedia"
                          rel="noopener noreferrer"
                        >
                          <FaInstagram
                            style={{ color: "#0e76a8", cursor: "pointer" }}
                          />
                        </a>
                      )}
                    </div>
                  </div>
                </Row>
                <Row className="c-content">
                  <Col xs={12} className="p-0">
                    <div className="company-name">{state?.companyName}</div>
                    <div className="company-oneline">{state?.oneLineIntro}</div>
                    <div className="company-description">{state?.overview}</div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          {state?.founders && state.founders.length > 0 && (
            <div style={{ display: "flex" }} className="section">
              <div style={{ marginTop: "45px", width: "100px", color: "#888" }}>
                <label>Founders</label>
              </div>
              <div style={{ flex: 1 }}>
                <Container fluid>
                  <Row className="c-header">
                    <Col xs={12} className="p-0">
                      {state?.founders.map((founder) => (
                        <div className="founder-wrapper">
                          <div className="f-detalis">
                            <div className="f-title">
                              {founder.name + ", " + founder?.title}
                            </div>
                            <div className="f-des">
                              <p>{founder.description}</p>
                            </div>
                          </div>
                          <div className="f-image">
                            <img src={founder.imageUrl} alt="" />
                          </div>
                        </div>
                      ))}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PublicCompanyView;
